import { getStudentHolidaysMockHandler } from '@/features/calendar/api';
import {
  acknowledgeParentConnectMockHandler,
  getParentConnectSessionsMockHandler,
} from '@/features/calendar/api/get-parent-connect-sessions';
import { scheduleMockHandler } from '@/features/calendar/api/get-schedule';

export const calendarHandlers = [
  scheduleMockHandler,
  getStudentHolidaysMockHandler,
  getParentConnectSessionsMockHandler,
  acknowledgeParentConnectMockHandler,
];
